export default __webpack_public_path__ + "static/media/doc-check-circle.79968801.svg";